import { createApp } from 'vue'
import App from './App.vue'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { plugin, defaultConfig } from '@formkit/vue';
import config from '../formkit.config.js';
import FontAwesomeIcon from '../fontawesome.js';
import '@formkit/themes/genesis';

// Import Vuetify styles
import 'vuetify/styles'

// Create Vuetify instance
const vuetify = createVuetify({
  components,
  directives,
})

const app = createApp(App)
app.use(vuetify)
app.use(plugin, defaultConfig(config))
app.component('font-awesome-icon', FontAwesomeIcon);

app.mount('#app')

